<template>
  <section class="messenger" v-bind:class="{'w-open': active}">

    <section v-if="active" class="w-popup" v-bind:class="{'w-fadein': active}">
      <section class="w-header">
        <svg @click="popMessenger()" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-badge-close">
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="#fff"/>
        </svg>

        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32" class="w-badge-fb">
          <path d=" M16 6C9.925 6 5 10.56 5 16.185c0 3.205 1.6 6.065 4.1 7.932V28l3.745-2.056c1 .277 2.058.426 3.155.426 6.075 0 11-4.56 11-10.185C27 10.56 22.075 6 16 6zm1.093 13.716l-2.8-2.988-5.467 2.988 6.013-6.383 2.868 2.988 5.398-2.987-6.013 6.383z" fill="#fff"/>
        </svg>
        <section class="w-text">Facebook Messenger</section>
      </section>
      <iframe class="w-frame" src="https://www.facebook.com/plugins/page.php?href=https://www.facebook.com/endorfine.fr&tabs=messages&adapt_container_width=1&small_header=1&hide_cover=1&height=280&width=302"></iframe>
    </section>

    <section @click="popMessenger()" class="w-icon">
      <svg v-if="active" xmlns="http://www.w3.org/2000/svg" class="w-icon-close" viewBox="0 0 24 24">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="#fff"/>
      </svg>

      <svg v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32" class="w-icon-mess">
        <path d=" M16 6C9.925 6 5 10.56 5 16.185c0 3.205 1.6 6.065 4.1 7.932V28l3.745-2.056c1 .277 2.058.426 3.155.426 6.075 0 11-4.56 11-10.185C27 10.56 22.075 6 16 6zm1.093 13.716l-2.8-2.988-5.467 2.988 6.013-6.383 2.868 2.988 5.398-2.987-6.013 6.383z" fill="#fff"/>
      </svg>
    </section>
  </section>
</template>

<script>
export default {
  name: 'Messenger',
  data () {
    return {
      active: false
    }
  },
  methods: {
    popMessenger () {
      if (this.active) this.active = false
      else this.active = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Widget_Messenger.vue